import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-databases',
  templateUrl: './databases.component.html',
  styleUrls: ['./databases.component.scss']
})
export class DatabasesComponent implements OnInit {

  titleSectionProp: any = {
    class: 'text-center iq-title-box-2',
    title: '',
    titleIcon: '',
  };

  List: any[] =[
    { title: 'WE_MIGRATE_ALL_SYSTEMS', image: './assets/images/se-icons/migrate-db.png', desc: 'WE_MIGRATE_ALL_SYSTEMS_DESC'},
    { title: 'WE_MIGRATE_ALL_APPS', image: './assets/images/se-icons/migrate-app.png', desc: 'WE_MIGRATE_ALL_APPS_DESC'},
    { title: 'WE_HOST_YOUR_DB_AND_APPS', image: './assets/images/se-icons/host-app.png', desc: 'WE_HOST_YOUR_DB_AND_APPS_DESC'}
  ]
  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute
  ) { }

  ngOnInit(): void {
  }

}
